// extracted by mini-css-extract-plugin
module.exports = {"section-header":"section-header__FqW-g","section-title":"section-title__2lqP6","section-sub-title":"section-sub-title__3onYg"};